export const REFRESH_TOKEN_DELAY = 1000 * 60
export const API = '/api/v1'

export const ROUTE_LOGGED_IN = 'pools'
export const ROUTE_LOGGED_OUT = 'login'

export const CURRENCY = '$'

const PRODUCT_META_FIELDS = {
  shared: (metadata) => {
    const fields = [
      `${metadata.clusters} clusters per month`,
    ]
    if(metadata.prewarm_mode == 'timeout') {
      fields.push(`Pre-warmed pool only stays running for ${metadata.prewarm_timeout}`)
    }
    else if(metadata.prewarm_mode == 'limit') {
      fields.push(`Permanent pre-warmed pool size of ${metadata.prewarm_limit}`)
    }
    return fields
  },
  dedicated: (metadata) => {
    const fields = [
      metadata.cpu,
      metadata.ram,
      metadata.storage,
    ]
    return fields
  }
}

const settings = {
  API,
  PRODUCT_META_FIELDS,
}

export default settings